import React from 'react';
import Spacer from '../../../../components/Spacer';
import {
  NormalText,
  PageTitle,
} from '../../../../components/typography/Typography';
import TextInput from '../../../../components/input/TextInput';
import Button from '../../../../components/input/Button';
import { FormData, FormDataUpdates } from '.';
import { Buttons } from '../Buttons';
import { HelpText } from '../../../../components/HelpText';
import styled from 'styled-components';

const Container = styled.div``;

type Props = {
  onClose?: () => void;
  onNext?: () => void;
  formData: FormData;
  updateFormData: (updates: FormDataUpdates) => void;
};

function DescribeAPI({ onClose, onNext, formData, updateFormData }: Props) {
  return (
    <Container>
      <PageTitle>Create an API</PageTitle>
      <Spacer vertical spacing={2} />
      <NormalText>
        Creating an API gives you the ability to authenticate users who
        subscribe to your API on the PayPI platform.
      </NormalText>
      {/* <Spacer vertical spacing={4} /> */}
      {/* <ProcessBar
        process={[
          // { text: 'Select your API', checked: true },
          { text: 'Describe your API', checked: true },
        ]}
      /> */}
      <Spacer vertical spacing={4} />
      <TextInput
        label='API Name'
        value={formData.apiName}
        onChange={(text) => {
          updateFormData({ apiName: text });
        }}
        placeholder={'e.g PDF to JPG converter'}
        extraInfo={
          <HelpText type='help'>
            Use a name your customers will recognize
          </HelpText>
        }
      />
      <Spacer vertical spacing={2} />
      <TextInput
        label='API Description'
        value={formData.apiDescription}
        onChange={(text) => {
          updateFormData({ apiDescription: text });
        }}
        placeholder={
          'e.g Takes uploaded PDF files and returns them as JPG files'
        }
        extraInfo={<HelpText type='help'>Explain what your API does.</HelpText>}
      />
      <Spacer vertical spacing={2} />
      <Buttons>
        <Button background={'#bab8c5'} color={'white'} onClick={onClose}>
          Cancel
        </Button>
        <Button color={'white'} onClick={onNext}>
          Create API
        </Button>
      </Buttons>
    </Container>
  );
}

export default DescribeAPI;
